(()=>{
if(customElements.get('as-samantha-carat-preview'))return;
const shapes={"Radiant":{"dimensions3":{"length":10.4,"width":7.2},"dimensions10":{"length":15.65,"width":10.85},"viewBox":"126 166 796 1173","imageWidth":1044,"imageHeight":1507,"url":"https://cdn.shopify.com/s/files/1/0833/7729/1513/files/crystal-radiant-slider-stone-v2.png?v=1792541055"},"Oval":{"ratio":1.45,"width3":8,"viewBox":"316 174 623 885","imageWidth":1254,"imageHeight":1254,"url":"https://cdn.shopify.com/s/files/1/0833/7729/1513/files/paige-oval-slider-stone.png?v=1792542491"},"Round":{"dimensions3":{"length":9.2,"width":9.2},"dimensions10":{"length":14.5,"width":14.5},"viewBox":"294 289 665 670","imageWidth":1254,"imageHeight":1254,"url":"https://cdn.shopify.com/s/files/1/0833/7729/1513/files/whitney-round-slider-center.png?v=1792546463"},"Pear":{"ratio":1.6,"width3":7.3,"viewBox":"272 61 710 1115","imageWidth":1254,"imageHeight":1254,"url":"https://cdn.shopify.com/s/files/1/0833/7729/1513/files/paige-pear-slider-center.png?v=1792549032"},"Square Cushion":{"ratio":1,"width3":8.2,"viewBox":"199 207 857 855","imageWidth":1254,"imageHeight":1254,"url":"https://cdn.shopify.com/s/files/1/0833/7729/1513/files/paige-square-cushion-slider-center.png?v=1792549039"},"Emerald":{"ratio":1.45,"width3":7.3,"viewBox":"267 146 720 981","imageWidth":1254,"imageHeight":1254,"url":"https://cdn.shopify.com/s/files/1/0833/7729/1513/files/paige-emerald-slider-center.png?v=1792549045"}};
const remembered={view:'original',shape:null};

class SamanthaPreview extends HTMLElement {
 connectedCallback(){
  if(this.dataset.ready)return;
  this.range=this.querySelector('input[type="range"]');
  this.stage=this.querySelector('.as-samantha-carat-stage');
  this.tabs=this.tabs||this.querySelector('.as-samantha-carat-tabs');
  this.view=remembered.view;
  this.controller=new AbortController();
  const signal=this.controller.signal;
  this.tabs.querySelectorAll('[data-view]').forEach(b=>b.addEventListener('click',()=>{
   this.view=b.dataset.view;remembered.view=this.view;this.render();
  },{signal}));
  this.range.addEventListener('input',()=>this.render(),{signal});
  this.range.addEventListener('change',()=>this.applyCarat(),{signal});
  document.addEventListener('change',e=>{
   if(e.target.closest('variant-picker')===this.picker())this.queueSync();
  },{signal});
  document.addEventListener('variant:update',()=>this.queueSync(),{signal});
  this.observer=new MutationObserver(records=>{
   this.moveTabs();
   if(records.some(r=>r.target.closest?.('variant-picker')||[...r.addedNodes].some(n=>n.matches?.('variant-picker')||n.querySelector?.('variant-picker'))))this.queueSync();
  });
  const product=this.closest('product-component');
  if(product)this.observer.observe(product,{childList:true,subtree:true});
  this.dataset.ready='true';
  this.sync();this.moveTabs();
 }
 disconnectedCallback(){
  this.controller?.abort();this.observer?.disconnect();clearTimeout(this.syncTimer);
  this.tabs?.remove();delete this.dataset.ready;
 }
 queueSync(){clearTimeout(this.syncTimer);this.syncTimer=setTimeout(()=>{if(this.isConnected)this.sync()},0)}
 moveTabs(){
  const heading=this.closest('product-component')?.querySelector('.product-details h1');
  const target=heading?.closest('.text-block')||heading;
  if(target&&target.previousElementSibling!==this.tabs)target.before(this.tabs);
 }
 picker(){return this.closest('product-component')?.querySelector('variant-picker')}
 stoneSelect(){return this.picker()?.querySelector('select[name="options[Center Stone]"]')}
 parse(text){
  return {shape:text?.match(/\b(Square Cushion|Radiant|Oval|Round|Pear|Emerald)\b/i)?.[1]?.toLowerCase(),carat:Number(text?.match(/(\d+(?:\.\d+)?)\s*ct/i)?.[1]),grade:/E\s*VVS2/i.test(text||'')?'E VVS2':'F VS1'};
 }
 shapeName(text){const key=this.parse(text).shape;return Object.keys(shapes).find(s=>s.toLowerCase()===key)}
 sync(){
  const select=this.stoneSelect(),text=select?.selectedOptions[0]?.textContent||'';
  const shape=this.shapeName(text);
  if(!shape){this.dataset.view='original';return}
  const parsed=this.parse(text);
  this.shape=shape;
  if(remembered.shape&&remembered.shape!==shape){this.view='original';remembered.view='original'}
  remembered.shape=shape;
  this.sizes=[...new Set([...select.options].filter(o=>!o.disabled&&this.shapeName(o.textContent)===shape).map(o=>this.parse(o.textContent).carat))].filter(Number.isFinite).sort((a,b)=>a-b);
  if(!this.sizes.length){this.dataset.view='original';return}
  this.range.min=String(this.sizes[0]);this.range.max=String(this.sizes.at(-1));
  this.range.value=String(this.sizes.includes(parsed.carat)?parsed.carat:this.sizes[0]);
  const ticks=this.querySelector('.as-samantha-carat-ticks');
  const key=this.sizes.join(',');
  if(ticks.dataset.sizes!==key){
   ticks.replaceChildren(...this.sizes.map(n=>{const span=document.createElement('span');span.textContent=n+' ct';return span}));
   ticks.dataset.sizes=key;
  }
  this.render();
 }
 dimensions(n){
  const s=shapes[this.shape];
  if(s.dimensions3&&s.dimensions10){
   if(n<3){const scale=Math.cbrt(n/3);return {width:s.dimensions3.width*scale,length:s.dimensions3.length*scale}}
   const t=Math.max(0,Math.min(1,(Math.cbrt(n)-Math.cbrt(3))/(Math.cbrt(10)-Math.cbrt(3))));
   return {
    width:s.dimensions3.width+(s.dimensions10.width-s.dimensions3.width)*t,
    length:s.dimensions3.length+(s.dimensions10.length-s.dimensions3.length)*t
   };
  }
  const width=s.width3*Math.cbrt(n/3);
  return {width,length:width*s.ratio};
 }
 render(){
  if(!this.shape)return;
  const config=shapes[this.shape];
  let n=Number(this.range.value);
  if(this.sizes?.length&&!this.sizes.includes(n)){
   n=this.sizes.reduce((best,v)=>Math.abs(v-n)<Math.abs(best-n)?v:best,this.sizes[0]);this.range.value=String(n);
  }
  const dimensions=this.dimensions(n),ratio=dimensions.length/dimensions.width;
  this.dataset.view=this.view;
  this.querySelector('[data-size-label]').textContent=this.shape+' center size';
  this.querySelector('output').textContent=n+' ct';
  this.range.setAttribute('aria-label',this.shape+' center diamond carat size');
  this.range.setAttribute('aria-valuetext',n+' carats, '+this.shape);
  this.tabs.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===this.view)));
  this.querySelector('[data-size-note]').textContent='Approximate white gold preview · '+(this.shape==='Round'?'Round center':ratio.toFixed(2)+' length-to-width ratio')+'. Actual diamond dimensions vary.';
  if(this.stage.dataset.shape!==this.shape){
   const svg=this.stage.querySelector('svg'),image=svg.querySelector('image');
   svg.setAttribute('viewBox',config.viewBox);
   image.setAttribute('href',config.url);image.setAttribute('width',config.imageWidth);image.setAttribute('height',config.imageHeight);
   this.stage.dataset.shape=this.shape;
  }
  this.stage.style.setProperty('--stone-ratio','1 / '+ratio);
  this.stage.style.setProperty('--stone-width',(dimensions.width*14/8)+'%');
  this.stage.setAttribute('aria-label',n+' carat '+this.shape+' diamond on-hand size preview');
 }
 applyCarat(){
  const s=this.stoneSelect(),status=this.querySelector('.as-samantha-carat-status');
  if(!s)return;
  const current=this.parse(s.selectedOptions[0]?.textContent),n=Number(this.range.value);
  const option=[...s.options].find(o=>{
   const v=this.parse(o.textContent);
   return !o.disabled&&v.shape===this.shape.toLowerCase()&&v.carat===n&&v.grade===current.grade;
  });
  if(!option){status.textContent='Choose an available center size in the product options.';return}
  status.textContent='';s.value=option.value;s.dispatchEvent(new Event('change',{bubbles:true}));
 }
}
customElements.define('as-samantha-carat-preview',SamanthaPreview);
})();
